export class GradientElement {
  color = '';
  position = '';
}

export class GradientColor {
    direction: string;
    gradient: Array<GradientElement>;
    constructor() {
      this.direction = '90deg';
      this.gradient = [{
        color: '#ffffff',
        //color: 'red',
        position: '0%'
      }, {
        color: '#000000',
        position: '100%'
      }];
    }
}

export enum ColorType {
  Color,
  GradientColor,
  Image
}
